import React, { Component } from "react";
import Head from "next/head";
import { connect } from "react-redux";
import withRouterPageLayout from "@components/withRouterPageLayout";

import { getRegionsWithStores } from "@lib/helpers";
import { getRegions } from "@store/user/actions";
import { getStoreByUrlPath, getStores } from "@store/stores/actions";
import { getSupportCategories } from "@store/support/actions";

import Breadcrumbs from "@components/Breadcrumbs";
import SupportLayout from "@containers/Support/Layout";
import StoresLayout from "@components/Stores/StoresLayout";
import StoreContainer from "@containers/Stores/Store";
import ErrorPage from "@containers/ErrorPage";
class StorePage extends Component {
  render() {
    const { store, regions, stores, supportCategories } = this.props;

    // Check store data
    if (!store || !regions) {
      return <ErrorPage>{`Nu au fost gasite magazine`}</ErrorPage>;
    }

    // Find store region name
    const storeRegion = regions.find((region) => store.region_id === region.id);

    const regionsList = getRegionsWithStores({ regions, stores });

    return (
      <>
        <Head>
          <title>Magazin {store.name}</title>
        </Head>

        <Breadcrumbs
          className="pt-3"
          breadcrumbs={[
            {
              id: 1,
              level: 2,
              name: `Suport clienti`,
              url_key: "suport-clienti/",
            },
            {
              id: 2,
              level: 3,
              name: `Magazine`,
              url_key: "magazine/",
            },
            {
              id: 3,
              level: 3,
              name: storeRegion.name,
              url_key: `magazine/${storeRegion.url_key}/`,
            },
            {
              id: 4,
              level: 99,
              name: store.name,
            },
          ]}
        />

        <SupportLayout
          categories={supportCategories}
          back={{ title: `Inapoi la lista magazine`, slug: "/magazine/" }}
        >
          <StoresLayout title={store.name} regions={regionsList}>
            <StoreContainer store={store} />
          </StoresLayout>
        </SupportLayout>
      </>
    );
  }
}

StorePage.getInitialProps = async (ctx) => {
  const { reduxStore, query } = ctx;
  const { regionUrlKey, placeUrlKey, storeUrlKey } = query;

  // Get data from store
  const { categories } = reduxStore.getState().support;
  const { regions } = reduxStore.getState().user;
  const { stores } = reduxStore.getState();
  const currentStoreInReduxStore = reduxStore.getState().stores.currentStore;

  // Recompose url_key for store
  const queryUrlPathStore = `${regionUrlKey}/${placeUrlKey}/${storeUrlKey}`;

  const promises = [];

  // Load region data
  !categories && promises.push(reduxStore.dispatch(getSupportCategories()));
  !regions && promises.push(reduxStore.dispatch(getRegions()));
  !stores.data && promises.push(reduxStore.dispatch(getStores()));

  // Check if store data is already loaded
  // TODO: Could be further optimized by checking
  // if store is already loaded in stores
  // Refactor state.stores.data
  // + move regions from state.user.regions to regions

  const urlKeyInCurrentStore =
    currentStoreInReduxStore && currentStoreInReduxStore.url_key;

  if (queryUrlPathStore !== urlKeyInCurrentStore) {
    promises.push(reduxStore.dispatch(getStoreByUrlPath(queryUrlPathStore)));
  }

  await Promise.all(promises);

  return { regionUrlKey, placeUrlKey, storeUrlKey };
};

StorePage.pageLayout = "default";
StorePage.layoutProps = {
  displaySearch: false,
};

export default withRouterPageLayout(
  connect((state) => ({
    stores: state.stores.data,
    regions: state.user.regions,
    store: state.stores.currentStore,
    supportCategories: state.support.categories,
  }))(StorePage)
);
